<template>
  <div class="tables-basic">
      <div v-if="loading" class="page-loading-container">
          <b-spinner label="Loading..." ></b-spinner>
      </div>
      <div v-else>
      <div class="float-right" id="top">
          <b-pagination-nav v-model="currentPage" :link-gen="linkGen()" use-router :number-of-pages="numberOfPages" base-url="#" first-number last-number  align="right"></b-pagination-nav>
      </div>

    <h2 class="page-title">Links</h2>
      <b-alert v-if="!scanStatus.completed" show variant="primary"><b-spinner label="Loading..." style="width:16px;height:16px"></b-spinner> Check in progress.<br>
          Results will show up here automatically</b-alert>
    <b-row v-if="links">
      <b-col>
        <Widget
        ><div class="table-responsive">
                <table class="table table-hover" >
                    <thead>
                    <tr>
                        <th scope="col">Url</th>
                        <th scope="col">Status</th>
                        <th scope="col">Pages</th>

                    </tr>
                    </thead>
                    <tbody>
                    <tr :class="{spelling: true, blur: false}" v-for="(link, index) in links">
                        <td width="75%" class="link-entry">
                            <div v-if="link.redirect_status">
                               <a :href="link.url" target="_blank" title="External Link">{{link.url}}</a>
                                <div  class="link-redirect">
                                Redirected to: <a :href="link.final_url" target="_blank" title="External Link">{{link.final_url}}</a>
                                </div>
                            </div>
                            <div v-else>
                                <a :href="link.url" target="_blank" title="External Link">{{link.url}}</a>
                            </div>
                        </td>
                        <td width="35%" style="vertical-align:middle">
                            <div v-if="link.valid_for_status_check">
                            <div v-if="!link.checked_at"> <b-spinner label="Loading..." style="height:16px;width:16px;color:gray;font-size:8px"></b-spinner></div>
                            <b-badge v-else :variant="link.variant"  :title="link.error_text">{{link.final_status}}</b-badge>
                            </div>
                            <div class="link-status-redirect" v-if="link.redirect_status"><span :title="link.redirect_message">{{link.redirect_status}}</span></div>

                        </td >
                        <td>
                            <router-link :to="{ name: 'ExploreLinkDetails', query: {url: link.url} }"><b><b-badge style="width:20px;padding: 0.4em 0.4em;" pill variant="secondary" :title="`Show pages.`"> {{link.pageCount}}</b-badge></b></router-link>
                            </td>
                        </tr>
                    </tbody>
                </table>
        </div>
        </Widget>

      </b-col>
    </b-row>
          <div class="float-right">
              <b-pagination-nav v-model="currentPage" :link-gen="linkGen('#top')" use-router :number-of-pages="numberOfPages" base-url="#" first-number last-number  align="right"></b-pagination-nav>
          </div>
      </div>
  </div>
</template>

<script>
import Widget from '@/components/Widget/Widget';
import DemoNotice from "@/components/DemoNotice/DemoNotice";

import gql from "graphql-tag";
import { mapState } from 'vuex';
import axios from "axios";
export default {
  name: 'Tables',
  components: { Widget, DemoNotice },
  apollo: {
    $subscribe: {
      websites_website: {
        query() {
          return gql`subscription {
                  websites_website(where: {id: {_eq: ${this.activeSite.id}}}) {
                  websites_links(where: {active: {_eq: true}}, limit: ${this.pageSize}, offset: ${(this.currentPage - 1) * this.pageSize || 0}, order_by: {id: asc}){
                      url
                      final_url
                      valid_for_status_check
                      is_broken
                      final_status
                      error
                      redirect_status
                      checked_at
                      websites_link_pages_aggregate(where: {websites_crawledpage: {is_latest: {_eq: true}}}){
                          aggregate{
                            count
                          }
                      }
                    }
                    websites_links_aggregate(where: {active: {_eq: true}}){
                      aggregate{
                        count
                      }
                    }
                  }
          }`
        },
        skip () {
          return !this.activeSite.id || (this.dataLoaded && this.scanStatus.completed);
        },
        result (data) {

          let pageCount = data.data.websites_website[0].websites_links_aggregate.aggregate.count;
          this.numberOfPages = Math.ceil(pageCount/this.pageSize);
          this.numberOfPages = Math.max(this.numberOfPages, 1);

          this.links = [];

          for (let entry of data.data.websites_website[0].websites_links){
            let redirectMessage = '';
            let finalStatus = entry.final_status;
            if (finalStatus === 0){
              finalStatus = entry.error && entry.error.type;
            }
            if (entry.redirect_status === 301 || entry.redirect_status === 308){
              redirectMessage = 'Moved Permanently'
            }
            else if (entry.redirect_status === 302 || entry.redirect_status === 307){
              redirectMessage = 'Moved Temporarily'
            }
            else if (entry.redirect_status === -5){
              redirectMessage = 'Meta Redirect';
              entry.redirect_status = 'Meta';
            }
            let variant = entry.is_broken ? 'danger' : 'success';
            if (entry.error && entry.error.type === 'Ignored'){
              variant = 'secondary';
              finalStatus = 'skipped';
              entry.error.message = 'Links from this domain cannot be checked.'
            }
            let linkEntry = {
              url: entry.url,
              final_url: entry.final_url,
              error: entry.error,
              error_text: entry.error && entry.error.message || 'Success',
              checked_at: entry.checked_at,
              variant: variant,
              final_status: finalStatus,
              valid_for_status_check: entry.valid_for_status_check,
              redirect_status: entry.redirect_status,
              redirect_message: redirectMessage,
              pageCount: entry.websites_link_pages_aggregate.aggregate.count,
              selectedPageIndex: 0,
            };
            this.links.push(linkEntry)
          }
          this.loading = false;
          this.dataLoaded = true;
        },

      },

    }
  },
  data() {
    return {
      pages: [],
      loading: true,
      dataLoaded: false,
      toastOptions: {
        theme: 'dark',
        position: 'bottomLeft',
      },
      links: [],
      currentPage: 0,
      numberOfPages: 1,
      pageSize: 15,
      row_selected: false,
    };
  },
  computed: {
    ...mapState({activeSite: 'activeSite', scanStatus: "scanStatus", user: 'user'}),
  },
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: 'Explore Links - PageWatch.dev',
    // all titles will be injected into this template
  },
  watch: {
    'activeSite': function () {
      this.dataLoaded = false;
    }
  },
  methods: {
    linkGen(hash) {
      if (!hash){
        hash = '';
      }
      return (pageNum) =>{
        return pageNum === 1 ? `?${hash}` : `?page=${pageNum}${hash}`
      };
    },
    mouseOver(spellingError, index){
      spellingError.selectedPageIndex = index;
    },
  },
  created() {
    this.$watch("$route",() => {
      this.currentPage = this.$route.query.page || 1;
      this.dataLoaded = false;
    }, {
      immediate: true
    });
  }
};
</script>

<style lang="scss">
    .link-redirect {
        font-size:9pt;
        color:gray;
        padding:4px;
    }
    .link-status-redirect{
        color:red;
        font-size:9pt;
        padding:4px;
    }
    .link-entry{
        max-width:580px;
        overflow:auto;
    }
    .broken-link-preview-image {
        border-radius: 50%;
        max-width: 250px;
        box-shadow: #bdc4e0 0px 0px 20px;
    }
</style>
